import script from "./DonationFailureDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DonationFailureDialog.vue?vue&type=script&setup=true&lang=js"

import "./DonationFailureDialog.vue?vue&type=style&index=0&id=284f3943&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-284f3943"]])

export default __exports__